import React from 'react';
import { CaretDoubleLeft, CaretDoubleRight, CaretLeft, CaretRight } from 'phosphor-react';

interface PaginatorLocalProps {
  page: number;
  pages: number;
  total: number;
  hasNext: boolean;
  hasPrevious: boolean;
  // eslint-disable-next-line no-unused-vars
  onPageChange: (page: number) => void;
  label?: string;
}

export const PaginatorLocal: React.FC<PaginatorLocalProps> = ({
  page,
  pages,
  total,
  hasNext,
  hasPrevious,
  onPageChange,
  label = 'registros',
}) => {
  if (pages <= 1) return null;

  const btnClass =
    'flex items-center justify-center rounded-md border border-border bg-body px-1 hover:opacity-80 disabled:opacity-50';

  return (
    <div className="flex items-center justify-between pt-4">
      <div className="text-muted-foreground text-xs text-gray-500">
        {total} {label}
      </div>
      <div className="flex space-x-2">
        <div className="text-muted-foreground self-center text-sm">
          Página(s) {page} de {pages}
        </div>
        <button
          type="button"
          aria-label="primeira"
          className={btnClass}
          onClick={hasPrevious ? () => onPageChange(1) : undefined}
          disabled={!hasPrevious}
        >
          <CaretDoubleLeft size={16} weight="bold" />
        </button>
        <button
          type="button"
          aria-label="anterior"
          className={btnClass}
          onClick={hasPrevious ? () => onPageChange(page - 1) : undefined}
          disabled={!hasPrevious}
        >
          <CaretLeft size={16} weight="bold" />
        </button>
        <button
          type="button"
          aria-label="próxima"
          className={btnClass}
          onClick={hasNext ? () => onPageChange(page + 1) : undefined}
          disabled={!hasNext}
        >
          <CaretRight size={16} weight="bold" />
        </button>
        <button
          type="button"
          aria-label="última"
          className={btnClass}
          onClick={hasNext ? () => onPageChange(pages) : undefined}
          disabled={!hasNext}
        >
          <CaretDoubleRight size={16} weight="bold" />
        </button>
      </div>
    </div>
  );
};
